'use client'

import { useEffect } from 'react'

import { usePortalOnboardingPersistence } from '@apps/portal-onboarding/hooks'
import { PORTAL_ONBOARDING_PHASE } from '@apps/portal-onboarding/portal-onboarding.const'
import { usePortalOnboardingStore } from '@apps/portal-onboarding/stores/portal-onboarding.store'

export function usePortalOnboardingLifecycle(autoStart: boolean, isDesktop: boolean) {
  const phase = usePortalOnboardingStore((state) => state.phase)
  const openWelcome = usePortalOnboardingStore((state) => state.openWelcome)
  const reset = usePortalOnboardingStore((state) => state.reset)
  const { shouldAutoStart, markCompleted } = usePortalOnboardingPersistence()

  useEffect(() => {
    if (!autoStart || !isDesktop || !shouldAutoStart) return
    openWelcome()
  }, [autoStart, isDesktop, openWelcome, shouldAutoStart])

  useEffect(() => {
    if (phase !== PORTAL_ONBOARDING_PHASE.completed) return
    markCompleted()
    reset()
  }, [markCompleted, phase, reset])
}
